import { CarouselSlider } from './CarouselSlider.js';

customElements.define('carousel-slider', CarouselSlider);
